import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { useSelector } from "react-redux";
import axios from "axios";
import Modal from "../Modal/Modal";
import ProgressBar from "../ProgressBar";
import useAuth from "../../hooks/useAuth";
import { BASE_URL } from "../../utils/Element";
import verified from "../../assets/images/verified.png";
import { NotificationManager } from "react-notifications";
import { RiDownloadCloud2Line as DownloadIcon } from "react-icons/ri";

const ImportModal = ({ showModal, onClose, from, onCallApi }) => {
  const userType = useSelector((state) => state.userType);
  const [config, configFormData] = useAuth();
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [disable, setDisable] = useState(false);
  const [importRes, setImportRes] = useState("");

  const contactLink = "https://stage-be.tri-oakcrm.com/contact-sample-sheet.xlsx";
  const buyerLink = "https://stage-be.tri-oakcrm.com/buyers-sample-sheet.csv";
  const propertyLink = "https://stage-be.tri-oakcrm.com/property-sample-sheet.xlsx";

  const handleDownloadTemplate = () => {
    const url = from === "contact" ? contactLink : from === "buyer" ? buyerLink : from === "property" ? propertyLink : "";
    const tempLink = document.createElement("a");
    tempLink.href = url;
    tempLink.setAttribute("download", `${from}-sample-sheet`);
    tempLink.click();
  };

  const handleImport = () => {
    setDisable(true);

    const sendData = {
      file: file,
      user_id: userType,
      mark_as_lead: 1,
      type: from,
    };

    const propertyData = {
      file: file,
      user_id: userType,
    };

    const dataToSend = from === "property" ? propertyData : sendData;
    const url = from === "property" ? "import-property" : "import-Contacts";

    axios
      .post(`${BASE_URL}/${url}`, dataToSend, configFormData)
      .then((res) => {
        setImportRes(res?.data?.message);
        onCallApi();
        if (res?.data?.message) {
          NotificationManager.success(res?.data?.message);
        }
      })
      .catch((err) => {
        setImportRes("");
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      })
      .finally(() => {
        setDisable(false);
      });
  };

  const handleComplete = () => {
    setFile(null);
    setFileName("");
    setImportRes("");
    onClose();
  };

  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      const reader = new FileReader();

      reader.onload = () => {
        const binaryStr = reader.result;
      };
      reader.readAsDataURL(file);
      setFile(file);
      setFileName(file?.name);
    });
  }, []);

  const { getRootProps, getInputProps, acceptedFiles, fileRejections } = useDropzone({
    onDrop,
    maxFiles: 1,
    accept: {
      "text/*": [".csv", ".xlsx", ".xls"],
    },
  });

  return (
    <Modal title={"Import File"} width="600px" desc={"Quickly populate your database by importing data directly from a CSV file."} show={showModal} onClose={onClose}>
      {file === null ? (
        <>
          <div {...getRootProps()}>
            <input {...getInputProps()} />
            <div class="flex items-center justify-center w-full">
              <div className="flex flex-col items-center justify-center w-full h-48 border-2 green-b border-dashed  cursor-pointer bg-gray-50 dark:hover:bg-bray-800 hover:bg-gray-100">
                <div class="flex flex-col items-center justify-center gap-1">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M23.8158 28.8167L21.6658 30.9833V21.6667C21.6658 21.2246 21.4902 20.8007 21.1776 20.4881C20.865 20.1756 20.4411 20 19.9991 20C19.5571 20 19.1331 20.1756 18.8206 20.4881C18.508 20.8007 18.3324 21.2246 18.3324 21.6667V30.9833L16.1824 28.8167C16.027 28.6613 15.8425 28.538 15.6395 28.4539C15.4365 28.3698 15.2189 28.3265 14.9991 28.3265C14.7793 28.3265 14.5617 28.3698 14.3587 28.4539C14.1556 28.538 13.9711 28.6613 13.8158 28.8167C13.6604 28.9721 13.5371 29.1565 13.453 29.3596C13.3689 29.5626 13.3256 29.7802 13.3256 30C13.3256 30.2198 13.3689 30.4374 13.453 30.6404C13.5371 30.8434 13.6604 31.0279 13.8158 31.1833L18.8158 36.1833C18.9743 36.3351 19.1612 36.454 19.3658 36.5333C19.5653 36.6215 19.781 36.667 19.9991 36.667C20.2172 36.667 20.4329 36.6215 20.6324 36.5333C20.837 36.454 21.0239 36.3351 21.1824 36.1833L26.1824 31.1833C26.4963 30.8695 26.6726 30.4438 26.6726 30C26.6726 29.5562 26.4963 29.1305 26.1824 28.8167C25.8686 28.5028 25.4429 28.3265 24.9991 28.3265C24.5552 28.3265 24.1296 28.5028 23.8158 28.8167ZM30.6991 10.3667C29.6807 8.02666 27.9232 6.08512 25.6959 4.83953C23.4685 3.59395 20.8942 3.11304 18.3674 3.4705C15.8405 3.82797 13.5006 5.00408 11.7062 6.81861C9.91173 8.63315 8.76173 10.986 8.43242 13.5167C6.84339 13.8972 5.44945 14.848 4.51531 16.1886C3.58117 17.5292 3.17189 19.1662 3.36519 20.7887C3.55849 22.4112 4.34091 23.9062 5.56386 24.9898C6.78682 26.0734 8.36513 26.6701 9.99908 26.6667C10.4411 26.6667 10.865 26.4911 11.1776 26.1785C11.4902 25.8659 11.6658 25.442 11.6658 25C11.6658 24.558 11.4902 24.134 11.1776 23.8215C10.865 23.5089 10.4411 23.3333 9.99908 23.3333C9.11503 23.3333 8.26718 22.9821 7.64206 22.357C7.01694 21.7319 6.66575 20.884 6.66575 20C6.66575 19.1159 7.01694 18.2681 7.64206 17.643C8.26718 17.0178 9.11503 16.6667 9.99908 16.6667C10.4411 16.6667 10.865 16.4911 11.1776 16.1785C11.4902 15.8659 11.6658 15.442 11.6658 15C11.67 13.0288 12.3729 11.1229 13.6495 9.62096C14.9262 8.11901 16.6939 7.11824 18.6387 6.79644C20.5834 6.47465 22.5793 6.85266 24.2717 7.86334C25.9641 8.87401 27.2434 10.4519 27.8824 12.3167C27.9777 12.6031 28.1489 12.8582 28.3779 13.0549C28.6069 13.2515 28.8849 13.3823 29.1824 13.4333C30.2925 13.6431 31.2989 14.2227 32.0375 15.0775C32.7761 15.9324 33.2034 17.0123 33.2497 18.1411C33.2961 19.2699 32.9589 20.3811 32.2929 21.2937C31.627 22.2063 30.6716 22.8665 29.5824 23.1667C29.3701 23.2214 29.1707 23.3174 28.9955 23.4492C28.8203 23.581 28.6727 23.746 28.5613 23.9348C28.4499 24.1236 28.3767 24.3325 28.346 24.5496C28.3153 24.7667 28.3277 24.9877 28.3824 25.2C28.4371 25.4123 28.5331 25.6117 28.6649 25.7869C28.7967 25.9621 28.9617 26.1097 29.1506 26.2211C29.3394 26.3325 29.5483 26.4057 29.7654 26.4364C29.9824 26.4671 30.2034 26.4547 30.4158 26.4C32.1697 25.9365 33.7245 24.9133 34.8441 23.4858C35.9636 22.0582 36.5868 20.3043 36.6188 18.4904C36.6509 16.6765 36.0901 14.9017 35.0217 13.4355C33.9533 11.9693 32.4356 10.8918 30.6991 10.3667Z" fill="#6F6F6F" />
                    <path d="M23.8158 28.8167L21.6658 30.9833V21.6667C21.6658 21.2246 21.4902 20.8007 21.1776 20.4881C20.865 20.1756 20.4411 20 19.9991 20C19.5571 20 19.1331 20.1756 18.8206 20.4881C18.508 20.8007 18.3324 21.2246 18.3324 21.6667V30.9833L16.1824 28.8167C16.027 28.6613 15.8425 28.538 15.6395 28.4539C15.4365 28.3698 15.2189 28.3265 14.9991 28.3265C14.7793 28.3265 14.5617 28.3698 14.3587 28.4539C14.1556 28.538 13.9711 28.6613 13.8158 28.8167C13.6604 28.9721 13.5371 29.1565 13.453 29.3596C13.3689 29.5626 13.3256 29.7802 13.3256 30C13.3256 30.2198 13.3689 30.4374 13.453 30.6404C13.5371 30.8434 13.6604 31.0279 13.8158 31.1833L18.8158 36.1833C18.9743 36.3351 19.1612 36.454 19.3658 36.5333C19.5653 36.6215 19.781 36.667 19.9991 36.667C20.2172 36.667 20.4329 36.6215 20.6324 36.5333C20.837 36.454 21.0239 36.3351 21.1824 36.1833L26.1824 31.1833C26.4963 30.8695 26.6726 30.4438 26.6726 30C26.6726 29.5562 26.4963 29.1305 26.1824 28.8167C25.8686 28.5028 25.4429 28.3265 24.9991 28.3265C24.5552 28.3265 24.1296 28.5028 23.8158 28.8167ZM30.6991 10.3667C29.6807 8.02666 27.9232 6.08512 25.6959 4.83953C23.4685 3.59395 20.8942 3.11304 18.3674 3.4705C15.8405 3.82797 13.5006 5.00408 11.7062 6.81861C9.91173 8.63315 8.76173 10.986 8.43242 13.5167C6.84339 13.8972 5.44945 14.848 4.51531 16.1886C3.58117 17.5292 3.17189 19.1662 3.36519 20.7887C3.55849 22.4112 4.34091 23.9062 5.56386 24.9898C6.78682 26.0734 8.36513 26.6701 9.99908 26.6667C10.4411 26.6667 10.865 26.4911 11.1776 26.1785C11.4902 25.8659 11.6658 25.442 11.6658 25C11.6658 24.558 11.4902 24.134 11.1776 23.8215C10.865 23.5089 10.4411 23.3333 9.99908 23.3333C9.11503 23.3333 8.26718 22.9821 7.64206 22.357C7.01694 21.7319 6.66575 20.884 6.66575 20C6.66575 19.1159 7.01694 18.2681 7.64206 17.643C8.26718 17.0178 9.11503 16.6667 9.99908 16.6667C10.4411 16.6667 10.865 16.4911 11.1776 16.1785C11.4902 15.8659 11.6658 15.442 11.6658 15C11.67 13.0288 12.3729 11.1229 13.6495 9.62096C14.9262 8.11901 16.6939 7.11824 18.6387 6.79644C20.5834 6.47465 22.5793 6.85266 24.2717 7.86334C25.9641 8.87401 27.2434 10.4519 27.8824 12.3167C27.9777 12.6031 28.1489 12.8582 28.3779 13.0549C28.6069 13.2515 28.8849 13.3823 29.1824 13.4333C30.2925 13.6431 31.2989 14.2227 32.0375 15.0775C32.7761 15.9324 33.2034 17.0123 33.2497 18.1411C33.2961 19.2699 32.9589 20.3811 32.2929 21.2937C31.627 22.2063 30.6716 22.8665 29.5824 23.1667C29.3701 23.2214 29.1707 23.3174 28.9955 23.4492C28.8203 23.581 28.6727 23.746 28.5613 23.9348C28.4499 24.1236 28.3767 24.3325 28.346 24.5496C28.3153 24.7667 28.3277 24.9877 28.3824 25.2C28.4371 25.4123 28.5331 25.6117 28.6649 25.7869C28.7967 25.9621 28.9617 26.1097 29.1506 26.2211C29.3394 26.3325 29.5483 26.4057 29.7654 26.4364C29.9824 26.4671 30.2034 26.4547 30.4158 26.4C32.1697 25.9365 33.7245 24.9133 34.8441 23.4858C35.9636 22.0582 36.5868 20.3043 36.6188 18.4904C36.6509 16.6765 36.0901 14.9017 35.0217 13.4355C33.9533 11.9693 32.4356 10.8918 30.6991 10.3667Z" fill="black" fill-opacity="0.2" />
                  </svg>

                  <p className="mb-2 body-S dark-M">Drag and drop your file here to upload.</p>
                  <p className="head-6 green-H underline">or click to select a file.</p>
                </div>
              </div>
            </div>
          </div>

          {fileRejections?.length !== 0 && <span className="body-S red-D">{fileRejections?.[0]?.errors?.[0]?.message}</span>}

          {from !== "company" && (
            <div className="flex justify-between mt-4">
              <p className="body-S dark-M">Download a premade template file.</p>
              <p role="button" className="green-H flex items-center gap-1" onClick={handleDownloadTemplate}>
                <DownloadIcon />
                <span className="head-5 green-H">Download Template</span>
              </p>
            </div>
          )}
        </>
      ) : (
        <div className="border-dashed border-2 text-center p-10 ">
          <img src={verified} alt="exp" className="mx-auto" />

          <p className=" mt-2 mb-4 ">
            {fileName} <span className="dark-M body-S">Complete: 100%</span>
          </p>
          <ProgressBar width={"100"} />
        </div>
      )}

      {importRes !== "" && <p className="body-S green-H mt-2">{importRes}</p>}

      <div className="mt-6">
        {importRes === "" ? (
          <>
            <button type="button" disabled={disable} className="save-button light-L head-5 w-30 green-bg-H" onClick={handleImport}>
              Upload File
            </button>
            <button type="button" onClick={onClose} className="green-H ml-5">
              Cancel
            </button>
          </>
        ) : (
          <button type="button" className="save-button light-L head-5 w-30 green-bg-H" onClick={handleComplete}>
            Complete
          </button>
        )}
      </div>
    </Modal>
  );
};

export default ImportModal;
